<script setup lang="ts">

import AllianceHeader from './Alliance/AllianceHeader.vue'
import AllianceTabs from './Alliance/AllianceTabs.vue'

</script>

<template>
  <div>
    <AllianceHeader/>
    <AllianceTabs/>
  </div>
</template>
